import { hasMinimumMobileSdkVersion } from 'conversations-visitor-message-history/utils/isInSDK';
import { connect } from 'react-redux';
import { getEnableSdkCloseButton } from '../widget-data/selectors/getEnableSdkCloseButton';
// @ts-expect-error untyped file
import CurrentView from './CurrentView';
import { getCurrentView } from './selectors/getCurrentView';
const mapStateToProps = state => {
  return {
    currentView: getCurrentView(state),
    enableSdkCloseButton: getEnableSdkCloseButton(state) && hasMinimumMobileSdkVersion({
      minMajor: 1,
      minMinor: 0,
      minPatch: 6
    })
  };
};
export default connect(mapStateToProps)(CurrentView);